import React from "react";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Link} from "@mui/material";
import '../../sass/topics.scss'


function handleClick(event) {
    event.preventDefault();
    console.info('You clicked a breadcrumb.');
}

export default function ContentHeader(props) {

    return (
        <div id="content-header" className="content_header" >
            <h1 className="content_header_title">{props.title}</h1>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link color="inherit" href={"/"} onClick={handleClick}>
                    {"ホーム"}
                </Link>
                {props.breadCrumbItems.map((value,index) => {
                    return (
                        <Link key={index} color="inherit" href={value.path} onClick={handleClick}>
                            {value.title}
                        </Link>
                    )
                })}
            </Breadcrumbs>
        </div>
    );
}